import { useCallback, useState } from 'react';
import AnimateHeight from 'react-animate-height';

const Collapse = ({
  title,
  children,
  className = '',
  isOpen: controlledOpen,
  onToggle,
  duration = 240,
}) => {
  const isControlled = typeof controlledOpen === 'boolean';
  const [internalOpen, setInternalOpen] = useState(false);
  const open = isControlled ? controlledOpen : internalOpen;
  const classes = ['collapse', className].filter(Boolean).join(' ');

  const toggle = useCallback(() => {
    const next = !open;
    if (!isControlled) {
      setInternalOpen(next);
    }
    if (onToggle) {
      onToggle(next);
    }
  }, [open, isControlled, onToggle]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    },
    [toggle],
  );

  return (
    <div className={classes}>
      <div className="br-list" role="list">
        <div
          className="br-item"
          role="button"
          tabIndex={0}
          data-toggle="accordion"
          onClick={toggle}
          onKeyDown={handleKeyDown}
          aria-expanded={open}
        >
          <div className="content">
            <div className="flex-fill">
              <div className="collapse-title">{title}</div>
              <i
                className={`collapse-toggle-icon fas fa-angle-${
                  open ? 'up' : 'down'
                }`}
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>
        <AnimateHeight
          duration={duration}
          height={open ? 'auto' : 0}
          animateOpacity
        >
          <div
            className="collapse-content"
            role="region"
            aria-hidden={open ? undefined : 'true'}
          >
            {children}
          </div>
        </AnimateHeight>
      </div>
    </div>
  );
};

export default Collapse;
